import React from "react";
import StatusBar from "../../preapps/StatusBar";
const CurrentProgressionIcon = (progressionId) => {
    if (progressionId < 5) {
        return "#b6d7a8";
    }
    if (progressionId > 4 && progressionId < 7) {
        return "#a2c4c9";
    }
    if (progressionId == 7) {
        return "#a4c2f4";
    }
    if (progressionId == 8) {
        return "#b4a7d6";
    }
    if (progressionId == 9) {
        return "#ffe599";
    }
    if (progressionId > 10 && progressionId < 16) {
        return "#ff6d01";
    }
    if (progressionId == 10 || (progressionId > 15 && progressionId < 19)) {
        return "#ffff00";
    }
    if (progressionId > 18 && progressionId < 25) {
        return "#34a853";
    }
    if (progressionId > 24 && progressionId < 26) {
        return "#ea4335";
    }
    if (progressionId == 27) {
        return "#810073";
    }
    return "";
};
const SalesPreappStatusBar = ({ status2Percentage, currentStatus, t }) => {
    return (
        <div className="table-div-td col-status col-status-hover">
            <StatusBar
                currentStatus={currentStatus ? currentStatus : ""}
                className="col-status-bar"
                style={{ maxWidth: "65px" }}
                percentage={status2Percentage}
                sales={true}
                statusColor={CurrentProgressionIcon(t[1].lead_progression_id)}
            />
        </div>
    );
};

export default SalesPreappStatusBar;
